// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pXNRT_Ft7J7cc7a3nVgR {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
}

.iyJwfd1trPmKclFuE6Yz {
  height: 95%;
  overflow-y: hidden;
  background: rgb(var(--primary-bg));
  z-index: 301;
  overflow-x: hidden;

  /* display: grid;
  grid-template-rows: auto 1fr; */
}

.Sy6WRTj0EUoRhw65sQcr {
  display: flex;
  flex-direction: column;
  height: calc(100% - 45px); 
  /* 39 */
}

.TAv2m0ElvpGXc9Ok9nam {
  height: calc(100% - 39px);
}

.umg5tIiOAaW_umXGw0Cw {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
  z-index: 305;
}

.FczPCTIVswByBWYRKleq {
  width: 100%;
}

.AJR6ThxGBykaKwFyb5Eu {
  color: rgb(var(--accent-brand));
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  background: transparent;
  cursor: pointer;
  border: none;
  z-index: 305;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.3s ease 0s;
}

.AJR6ThxGBykaKwFyb5Eu > svg {
  cursor: pointer;
  > path {
    stroke: rgb(var(--accent-brand));
  }
}

.AJR6ThxGBykaKwFyb5Eu:first-child {
  justify-content: flex-start;
}

.AJR6ThxGBykaKwFyb5Eu:hover {
  background: transparent;
}

.AJR6ThxGBykaKwFyb5Eu:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .modalTopButton:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.x7jwpmrTQR_AYIx1l3pR {
  font-size: 17px;
  font-weight: 760;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  text-align: center;
  margin: 0 auto;
}
.fxOYOlM4YP3aN4EnM9G4 {
  position: absolute;
  z-index: -1;
  width: 70%; 
  height: 40%;
  left: 50%;
  bottom: 0;
  border-radius: 600px;
  transform: translateX(-50%);
  background: rgba(0, 122, 255, 0.25);
  filter: blur(110px);
}

.W7SKm5geatmJS0uUs85Q {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 60%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(16, 185, 129, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}

.Vy_XIvDvy7VumR4KkRFT {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 60%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(234, 84, 111, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}`, "",{"version":3,"sources":["webpack://./src/pages/main/send/send.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;;EAElB;iCAC+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,SAAS;EACT,SAAS;EACT,oBAAoB;EACpB,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\n  height: 95%;\n  overflow-y: hidden;\n  background: rgb(var(--primary-bg));\n  z-index: 301;\n  overflow-x: hidden;\n\n  /* display: grid;\n  grid-template-rows: auto 1fr; */\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 45px); \n  /* 39 */\n}\n\n.content1 {\n  height: calc(100% - 39px);\n}\n\n.modalTop {\n  margin-left: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 15px;\n  z-index: 305;\n}\n\n.empty {\n  width: 100%;\n}\n\n.modalTopButton {\n  color: rgb(var(--accent-brand));\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  z-index: 305;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background 0.3s ease 0s;\n}\n\n.modalTopButton > svg {\n  cursor: pointer;\n  > path {\n    stroke: rgb(var(--accent-brand));\n  }\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  background: transparent;\n}\n\n.modalTopButton:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .modalTopButton:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.modalTitle {\n  font-size: 17px;\n  font-weight: 760;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  text-align: center;\n  margin: 0 auto;\n}\n.background {\n  position: absolute;\n  z-index: -1;\n  width: 70%; \n  height: 40%;\n  left: 50%;\n  bottom: 0;\n  border-radius: 600px;\n  transform: translateX(-50%);\n  background: rgba(0, 122, 255, 0.25);\n  filter: blur(110px);\n}\n\n.backgroundSuccess {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 60%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(16, 185, 129, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}\n\n.backgroundError {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 60%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(234, 84, 111, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `pXNRT_Ft7J7cc7a3nVgR`,
	"modal": `iyJwfd1trPmKclFuE6Yz`,
	"content": `Sy6WRTj0EUoRhw65sQcr`,
	"content1": `TAv2m0ElvpGXc9Ok9nam`,
	"modalTop": `umg5tIiOAaW_umXGw0Cw`,
	"empty": `FczPCTIVswByBWYRKleq`,
	"modalTopButton": `AJR6ThxGBykaKwFyb5Eu`,
	"modalTitle": `x7jwpmrTQR_AYIx1l3pR`,
	"background": `fxOYOlM4YP3aN4EnM9G4`,
	"backgroundSuccess": `W7SKm5geatmJS0uUs85Q`,
	"backgroundError": `Vy_XIvDvy7VumR4KkRFT`
};
export default ___CSS_LOADER_EXPORT___;
